import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'editor/src/store/index';

const getCustomerUploadedFonts = createSelector(
  (state: RootState) => state.fonts.uploadedFonts,
  (uploadedFonts) => uploadedFonts.filter((font) => !font.isMissing),
);

export default getCustomerUploadedFonts;
